import {
  BookingProductType,
  BookingState,
  BookingTariff,
  isBookingProductTypePackage,
  isBookingProductTypeTariff,
  SetProductBookingParkingReservation
} from '@products/models/booking.model';
import { LicensePlateNumber } from '@products/models/parking.model';
import { findBookedPackageTariff, findBookedTariff } from '@store/products/booking/product/product-booking.reducer';
import { cloneDeep } from 'lodash';

/**
 * Set parking reservation in booking
 * @description Set parking reservation in booking
 * @param state
 * @param props
 * @returns State
 */
export const setParkingReservationInBooking = (state: BookingState, props: SetProductBookingParkingReservation) => {
  const setProductBookingParkingReservation: SetProductBookingParkingReservation = cloneDeep(props);

  if (setProductBookingParkingReservation) {
    const cloneStateProductsList: BookingProductType[] = cloneDeep(state.list);
    const {
      productType,
      ticketTypeId,
      ticketPersonId,
      voucherCode,
      packageNumber,
      packageIndex,
      bookingReservationIndex,
      isValid,
      licensePlateNumber
    } = setProductBookingParkingReservation;

    const setParkingReservation = (
      bookedTariff: BookingTariff,
      index: number,
      licensePlateNumber: LicensePlateNumber,
      isValid: boolean
    ) => {
      const bookedTariffParkingReservation = bookedTariff.parkingReservations[index];
      if (bookedTariffParkingReservation) {
        bookedTariffParkingReservation.licensePlateNumber = licensePlateNumber;
        bookedTariffParkingReservation.isValid = isValid;
      }
    };

    cloneStateProductsList.forEach((bookedProductType) => {
      if (bookedProductType.productType === productType) {
        if (isBookingProductTypeTariff(bookedProductType)) {
          const bookedTariff = findBookedTariff(bookedProductType, ticketTypeId, ticketPersonId, voucherCode);

          if (bookedTariff) {
            setParkingReservation(bookedTariff, bookingReservationIndex, licensePlateNumber, isValid);

            return;
          }
        } else if (isBookingProductTypePackage(bookedProductType)) {
          bookedProductType.productTypes.forEach((bookedPackageProductType) => {
            if (isBookingProductTypeTariff(bookedPackageProductType)) {
              const bookedPackageTariff = findBookedPackageTariff(
                bookedPackageProductType,
                ticketTypeId,
                ticketPersonId,
                voucherCode,
                packageNumber,
                packageIndex
              );

              if (bookedPackageTariff) {
                setParkingReservation(bookedPackageTariff, bookingReservationIndex, licensePlateNumber, isValid);

                return;
              }
            }
          });
        }
      }
    });

    return {
      ...state,
      list: cloneStateProductsList
    };
  }

  return state;
};
